import { Box, Button, Grid, Stack } from "@mui/material";
import { TransForm } from "../common/TransForm/Index";
import leagueforminput from "../common/jsons/formConfigs/LeaguesForminput";
import leagueDetailsFormInput from '../common/jsons/formConfigs/LeagueDeatsilsForminput'
import { PageTitle } from "../common/PageTitle";
import Divider from '@mui/material/Divider';
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { useEffect, useState } from "react";
import { base_url } from "../backendurl/url";
import Axios from "axios";
import { Notification } from "../common/Notification";
import { CircularProgress } from "@material-ui/core";
import { Config } from "../../utils/commonFuctions/Token";
import { RefreshToken } from "../../utils/commonFuctions/RefreshToken";
import { FirebaseImageUpload } from "../common/FirebaseImageUpload";
import { S3ImageUpload } from "../common/S3ImageUpload";
import dayjs from 'dayjs';

export const LeaguesForm = ({ mode }) => {
  const [leagues, setLeaguesData] = useState([])
  const navigate = useNavigate();
  const [seassionYear, setSeassionYear] = useState([])
  const [Leagueinfo, setLeagueInfo] = useState({})

  const [seasson, setSeasson] = useState({})
  const [errorMessage, setErrorMessage] = useState('')
  const [notification, setnotification] = useState(false)
  const [isSystemLeagueSelected, setIsSystemLeagueSelected] = useState(false)
  const [isLoading, setIsLoading] = useState(false);

   // Function to extract error messages from the error response
  // const extractErrorMessages = (errorResponse) => {
  //   try {
  //     console.log(errorResponse, "errorResponse")
  //     if (errorResponse?.data?.errors && Array.isArray(errorResponse?.data?.errors)) {
  //       const errorMessages = [];
        
  //       errorResponse.data?.errors.forEach(errorGroup => {
  //         console.log(errorGroup, "errorGroup")
  //         if (Array.isArray(errorGroup)) {
  //           errorGroup.forEach(([fieldName, messages]) => {
  //             if (Array.isArray(messages)) {
  //               messages.forEach(message => {
  //                 errorMessages.push(`${fieldName}: ${message}`);
  //               });
  //             }
  //           });
  //         }
  //       });
        
  //       return errorMessages.join('\n');
  //     }
      
  //     if (errorResponse?.message) {
  //       return errorResponse.message;
  //     }
      
  //     return 'An error occurred while processing your request.';
  //   } catch (e) {
  //     return 'An unexpected error occurred.';
  //   }
  // };
  // Function to extract error messages from the error response
// const extractErrorMessages = (errorResponse) => {
//   try {
//     console.log(errorResponse, "errorResponse");

//     // Handle non_field_errors directly
//     if (errorResponse?.data?.non_field_errors && Array.isArray(errorResponse.data.non_field_errors)) {
//       return errorResponse.data.non_field_errors.join('\n');
//     }

//     // Handle generic errors if structured differently
//     if (errorResponse?.data?.errors && Array.isArray(errorResponse.data.errors)) {
//       const errorMessages = [];
//       errorResponse.data.errors.forEach(errorGroup => {
//         if (Array.isArray(errorGroup)) {
//           errorGroup.forEach(([fieldName, messages]) => {
//             if (Array.isArray(messages)) {
//               messages.forEach(message => {
//                 errorMessages.push(`${fieldName}: ${message}`);
//               });
//             }
//           });
//         }
//       });
//       return errorMessages.join('\n');
//     }

//     if (errorResponse?.message) {
//       return errorResponse.message;
//     }

//     return 'An error occurred while processing your request.';
//   } catch (e) {
//     return 'An unexpected error occurred.';
//   }
// };

const extractErrorMessages = (errorResponse) => {
  try {
    console.log(errorResponse, "errorResponse");

    // Handle non_field_errors directly
    if (errorResponse?.data?.non_field_errors && Array.isArray(errorResponse.data.non_field_errors)) {
      return errorResponse.data.non_field_errors.join('\n');
    }

    // Handle backend message inside data
    if (errorResponse?.data?.message) {
      return errorResponse.data.message;
    }

    // Handle generic errors if structured differently
    if (errorResponse?.data?.errors && Array.isArray(errorResponse.data.errors)) {
      const errorMessages = [];
      errorResponse.data.errors.forEach(errorGroup => {
        if (Array.isArray(errorGroup)) {
          errorGroup.forEach(([fieldName, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach(message => {
                errorMessages.push(`${fieldName}: ${message}`);
              });
            }
          });
        }
      });
      return errorMessages.join('\n');
    }

    // Fallback: root-level message
    if (errorResponse?.message) {
      return errorResponse.message;
    }

    return 'An error occurred while processing your request.';
  } catch (e) {
    return 'An unexpected error occurred.';
  }
};



  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      let leagueLogo = leagues.find(item=>item?.id == data?.league)

      // Use current year as default if no season_year is selected
      const currentYear = new Date().getFullYear();
      const seasonYear = data?.season_year || currentYear;

      let Leagueinfos = {
        league: data?.league,
        leaguename: data?.name,
        display_name: data?.name,
        season_year: seasonYear, // Use default current year if not selected
        logo: leagueLogo?.logo
      }

      console.log(Leagueinfos, "Leagueinfos")
      const response = await Axios.post(`${base_url}/api/pot/seasons`, Leagueinfos, Config);
      console.log(response, "responseLeagueForm");
      if (response?.status === 203) {
        const errorMsg = response?.data?.data?.message || 'An error occurred';
        setErrorMessage(errorMsg);
        setnotification(true);
      } else if (response?.status === 200) {
        let leaquesdata = response?.data?.data
        leaquesdata.start_date = dayjs(leaquesdata.start_date)
        leaquesdata.end_date = dayjs(leaquesdata.end_date)
        setLeagueInfo(leaquesdata);
        setnotification(false);
      }
    } 
    catch (error) {
      // RefreshToken(error,setErrorMessage,setnotification) 
      // console.error('Error submitting data:', error);
        if (error?.response?.status === 400 && error?.response?.data) {
        const errorMsg = extractErrorMessages(error.response.data);
        setErrorMessage(errorMsg);
        setnotification(true);
      } else {
        RefreshToken(error, setErrorMessage, setnotification);
      }
    } 
    finally {
      setIsLoading(false);
    }
  };

  const onleagueSubmit = async (data, name) => {
    try {
      if (name === 'fetch_ixtures') {
        navigate('autofixture', { state: data });
      } else {
        delete data.fetch_ixtures;
        delete data.manually_add_fixtures;

        data.standings = {};
        data.status = 'Active';
        data.display_name = seasson?.name;
        data.leaguename = seasson?.name;
        data.league = seasson?.league;
        data.season_year = seasson?.season_year;

        const imageFile = data?.league_logo;

        if (imageFile && typeof imageFile === 'object' && imageFile.name) {
          let imageUrl;

          if (base_url === process.env.REACT_APP_AWS_PROD) {
            const s3Result = await S3ImageUpload(imageFile);
            data.logo = s3Result?.location;
          } else {
            const firebaseUrl = await FirebaseImageUpload(imageFile);
            data.logo = firebaseUrl?.split('&')[0];
          }
        } else if (typeof imageFile === 'string') {
          data.logo = imageFile;
        }

        delete data.league_logo;

        Object.keys(data).forEach(key => {
          if (
            data[key] === null ||
            data[key] === undefined ||
            (typeof data[key] === 'object' && Object.keys(data[key]).length === 0)
          ) {
            delete data[key];
          }
        });

        console.log("Final data before submission:", data);

        const response = await Axios.post(`${base_url}/api/pot/seasons`, data, Config);

        if (response?.status === 203) {
          setErrorMessage('League in this Season Already Exists');
          setnotification(true);
        } else if (response?.status === 200) {
          navigate('manualfixture', { state: response?.data?.data });
          setnotification(false);
        }
      }
    } catch (error) {
      RefreshToken(error, setErrorMessage, setnotification);
      console.error("League submit error:", error);
    }
  };

  const getLeagues = async () => {
    try{
      const response = await Axios.get(`${base_url}/api/pot/configureleagues/list?status=true`, Config)
      let leaquename = response?.data?.data.map(item => {
        return {
          id: item?.id,
          name: item?.name,
          ...item,
        }
      })
      setLeaguesData(leaquename)
      
      // Modified to only include current year and next year
      const currentYear = new Date().getFullYear();
      let years = [
        { id: currentYear, name: currentYear.toString() },
        { id: currentYear + 1, name: (currentYear + 1).toString() }
      ];
      setSeassionYear(years)
    }
    catch(error){
      RefreshToken(error,setErrorMessage,setnotification) 
    }
  }

  useEffect(() => {
    getLeagues();
    
    // Set default season year to current year
    const currentYear = new Date().getFullYear();
    setSeasson(prev => ({
      ...prev,
      season_year: currentYear
    }));
  }, []);

  const handleCancel = async () => {
    navigate(-1);
  }

  const getFormData = (newFormData) => {
    let filterdata = leagues?.find(item => item.id == newFormData.league)
    
    // Ensure current year is set as default if no season_year is provided
    const currentYear = new Date().getFullYear();
    const updatedFormData = {
      ...newFormData,
      season_year: newFormData.season_year || currentYear
    };
    
    setSeasson(updatedFormData);
    setIsSystemLeagueSelected(filterdata?.system_league)
  }

  return (
    <Box  >
      <Box sx={{ px: 6, py: 3 }} alignContent="center">
        <Stack direction={'row'} sx={{ justifyContent: 'space-between' }} alignContent="center">
          <PageTitle pageTitle={'Add New Season'} />
          <Button sx={{ backgroundColor: '#E2E8F0', color: '#1C2434', width: '110px' }} onClick={handleCancel} >Cancel</Button>
        </Stack>
      </Box>
      <Divider sx={{ mb: 2, height: 4 }} />
      <Box style={{ position: 'relative' }}>
        {isLoading && (
          <Box
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 9999,
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <Box>
          <TransForm
            mode={mode}
            data={seasson}
            getFormData={getFormData}
            formInputs={[
              ...leagueforminput({
                leagues,
                seassionYear,
                isSystemLeagueSelected,
              }),
            ]}
            submitAction={onSubmit}
          />
          <TransForm
            submitAction={onleagueSubmit}
            data={Leagueinfo}
            mode={mode}
            formInputs={[
              ...leagueDetailsFormInput({
                leagues,
                seassionYear,
                isSystemLeagueSelected,
              }),
            ]}
          />
          <Notification
            message={errorMessage}
            setopen={setnotification}
            type={'error'}
            show={notification}
          />
        </Box>
      </Box>
      <Notification message={errorMessage} setopen={setnotification} type={'error'} show={notification} />
    </Box >
  );
};